import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {UnlockIcon} from '@primer/octicons-react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {UnlockedEventNode} from './issue-viewer-view-query-types'
import {TimelineRow} from './row/TimelineRow'

// RELAY-CLEANUP(UnlockedEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when IssueTimelineItem leaves Relay.
export type UnlockedEventFragment = RelayCompat<Pick<UnlockedEventNode, 'actor' | 'createdAt' | 'databaseId'>>

type UnlockedEventProps = {
  queryRef: UnlockedEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function UnlockedEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: UnlockedEventProps): React.ReactElement {
  const {actor, createdAt, databaseId} = queryRef

  const highlighted = String(databaseId) === highlightedEventId

  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={UnlockIcon}
    >
      <TimelineRow.Main>{`${LABELS.timeline.unlockedConversation} `}</TimelineRow.Main>
    </TimelineRow>
  )
}
